<template>
    <div>
        <form-loader v-if="loading" message="Laden..."/>
        <template v-if="!loading">
            <b-row>
                <b-col>
                    <p>
                        Met uw inschrijving in WoningNet regio Amsterdam kunt u de rechten die u daar heeft opgebouwd ook inzetten voor Woonmatch Waterland. Met uw WoningNet inschrijfnummer of het e-mailadres waarmee u bij WoningNet staat ingeschreven en uw geboortedatum haalt u uw behaalde punten over. Het hoogste aantal punten wordt altijd aangehouden.
                    </p>
                    <p>
                        Als u bij Woonmatch Waterland langer inschreven bent dan bij WoningNet Stadsregio Amsterdam, klik dan op de onderstaande knop. Uw inschrijfdatum wordt dan doorgegeven aan WoningNet Stadsregio Amsterdam en zal daar handmatig verwerkt worden in uw zoekrechten. Als uw inschrijfdatum bij Woonmatch daar niet binnen 5 werkdagen verwerkt wordt, adviseren wij u om contact op te nemen met WoningNet Stadsregio Amsterdam.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h3>
                        <strong>Uw huidige status</strong>:
                    </h3>
                    <span v-if="data.exists && data.canGet">
                        U heeft uw WoningNet inschrijving proberen te koppelen, maar uw gegevens waren niet bekend bij WoningNet
                    </span>
                    <span v-else-if="data.exists">
                        U heeft uw WoningNet inschrijving gekoppeld
                    </span>
                    <span v-else>
                        U heeft nog geen gekoppelde Woningnet inschrijving
                    </span>
                </b-col>
            </b-row>
            <div v-if="data.exists">
                <b-row>
                    <b-col>
                        <hr/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div v-html="data.table"></div>
                    </b-col>
                </b-row>
            </div>
            <div>
                <b-row>
                    <b-col>
                        <hr/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="form-label">
                        <label for="dob">Geboortedatum</label>
                    </b-col>
                    <b-col sm="6">
                        <b-form-input
                                id="dob"
                                size="sm"
                                :value="dutchDate(form.dob)"
                                disabled
                                placeholder=""
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="form-label">
                        <label for="dob">Inschrijfnummer of <br/>e-mailadres Woningnet</label>
                    </b-col>
                    <b-col sm="6">
                        <b-form-input
                                id="oldnumber"
                                size="sm"
                                value=""
                                placeholder=""
                                v-model="form.oldnumber"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button variant="success" size="sm" class="mr-2 text-center pull-right" @click.stop="getWNData">
                            Inschrijving ophalen
                        </b-button>
                        <b-button variant="success" size="sm" class="mr-2 text-center pull-right" @click.stop="sendWNData">
                            Inschrijving doorgeven
                        </b-button>
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col>
                    <hr/>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h3>
                        Uw Woonmatch Waterland rechten doorgeven aan WoningNet
                    </h3>
                </b-col>
            </b-row>
            <b-row>
                <b-col>

                </b-col>
            </b-row>

            <error-box v-if="postErrors.length > 0" :errors="postErrors"/>
            <FormButtons @next="next" @previous="$emit('previous')"/>
        </template>
    </div>
</template>

<script>
    import FormButtons from '@/components/_registration/FormButtons'
    import ErrorBox from '@/components/_registration/ErrorBox'
    import FormLoader from '@/components/_registration/FormLoader'
    import dateTransformers from '@/mixins/dateTransformers'
    import { registrationService } from '@/_services/registration.service'
    import { accountService } from '@/_services/account.service'

    export default {
        components: { FormButtons, ErrorBox, FormLoader },
        mixins: [dateTransformers],
        data: () => {
            return {
                data: {
                    canGet: true,
                    table: '',
                    exists: false
                },
                postErrors: false,
                loading: false,
                form: {
                    dob: '',
                    oldnumber: '',
                },
                activeInput: ''
            }
        },
        name: 'Wn',
        mounted() {
            this.$emit('validated', true)
            this.getData()
            registrationService.getSummary().then((data) => {
                this.form.dob = data.person.dob
            })
        },
        activated () {

        },
        methods: {
            getData() {
                registrationService.getWN().then((data) => {
                    this.data = data
                    this.data.table = this.data.table.replace('<table>', '<table class="table table-striped table-bordered">')
                    this.loading = false
                });
            },
            next () {
                this.submit()
            },
            submit () {

            },
            getWNData() {
                this.loading = true
                registrationService.postWN(this.form.oldnumber).then((data, err) => {
                    this.getData()
                })
            },
            sendWNData() {
                this.loading = true
                registrationService.putWN(this.form.oldnumber).then((data, err) => {
                    this.getData()
                })
            }
        }
    }
</script>

<style scoped>

</style>